"use client";

import React from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { getText } from "@/lib/i18n";
import FaqClient from "@/app/faq/index";

export const Landing = () => {
  // VPN 数据数组（支持外链 url 或站内 href）
  const vpnList: Array<{
    name: string;
    description: string;
    url?: string;
    href?: string;
    icon: string;
    iconBg: string;
    features: string[];
    cta: string;
  }> = [
    {
      name: "NCloudVPN",
      description:
        "NCloudVPN is known for its strict no-logs policy and advanced privacy features, ensuring your online activities remain private.",
      url: "https://xn--cloud-cl5i.net/#/register?code=No9VBfir",
      icon: "N",
      iconBg: "bg-blue-500",
      features: ["Privacy First", "Global Servers", "Encrypted"],
      cta: "Visit Site",
    },
    {
        name: "EEVPN",
        description:
          "EEVPN is known for its strict no-logs policy and advanced privacy features, ensuring your online activities remain private.",
        url: "https://www.eevpn66.com/#/register?code=1RH0eQVV",
        icon: "E",
        iconBg: "bg-blue-300",
        features: ["Privacy First", "Global Servers", "Encrypted"],
        cta: "Visit Site",
    },
    // {
    //   name: "良心云",
    //   description: "liangxinyun",
    //   url: "https://xn--9kqz23b19z.com/#/register?code=MShomcRd",
    //   icon: "L",
    //   iconBg: "bg-green-500",
    //   features: ["Global Access", "Fast Connect", "Reliable"],
    //   cta: "Visit Site",
    // },
    {
      name: "轻舟",
      description: "qingzhou",
      url: "https://qbgo.cc/hi/dBoHk1A8",
      icon: "Q",
      iconBg: "bg-blue-500",
      features: ["Global Access", "Fast Connect", "Reliable"],
      cta: "Visit Site",
    },
  ];

  return (
    <div className="min-h-screen   transition-colors duration-300">
      {/* Header Section */}
      <motion.div
        className="pt-32 pb-12"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <motion.h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-white mb-6 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              {getText("landing.title")}
            </motion.h1>
            <motion.p
              className="text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              {getText("landing.description")}
            </motion.p>
          </div>
        </div>
      </motion.div>

      {/* VPN Cards Grid */}
      <motion.div
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-20"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.6 }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {vpnList.map((vpn, index) => (
            <motion.div
              key={index}
              className="group relative"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 + index * 0.1, duration: 0.6 }}
              whileHover={{ y: -8 }}
            >
              <div className="h-full rounded-2xl p-8 shadow-lg dark:shadow-gray-900/25 border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl dark:hover:shadow-gray-900/40 hover:border-gray-300 dark:hover:border-gray-600">
                {/* Icon and Title */}
                <div className="flex items-center mb-6">
                  <div
                    className={`w-16 h-16 ${vpn.iconBg} rounded-2xl flex items-center justify-center text-white text-2xl font-bold shadow-lg`}
                  >
                    {vpn.icon}
                  </div>
                  <div className="ml-4">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                      {vpn.name}
                    </h3>
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6 text-base">
                  {vpn.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-8">
                  {vpn.features.map((feature, featureIndex) => (
                    <span
                      key={featureIndex}
                      className="px-3 py-1 text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full border border-gray-200 dark:border-gray-600"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Visit Button */}
                {vpn.href ? (
                  <Link
                    href={vpn.href}
                    className="block w-full text-center bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
                  >
                    {vpn.cta}
                  </Link>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      window.open(vpn.url, "_blank");
                    }}
                    className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
                  >
                    {vpn.cta}
                  </button>
                )}

                {/* Hover Effect Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-600/5 dark:from-blue-400/10 dark:to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl pointer-events-none"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Bottom CTA Section */}
      <motion.div
        className="border-gray-200 dark:border-gray-700"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
      >
        <div className="  px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-4">
            {getText("landing.help.title")}
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
            {getText("landing.help.description")}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              {getText("landing.help.secure")}
            </div>
            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
              {getText("landing.help.fast")}
            </div>
            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
              <div className="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
              {getText("landing.help.global")}
            </div>
          </div>
        </div>
      </motion.div>

      <FaqClient />
    </div>
  );
};
